import { Outlet, createFileRoute } from "@tanstack/react-router";

import { APP_ROUTES_TO } from "@/utils/routes";
import { FV_ROUTE_PERMISSIONS } from "@/pages/feature-videos/constants";

export const Route = createFileRoute(APP_ROUTES_TO.FEATURE_VIDEOS)({
    component: FeatureVideosLayout,
    staticData: {
        config: {
            breadcrumb: { title: "feature_videos", to: APP_ROUTES_TO.FEATURE_VIDEOS },
            title: "feature_videos",
        },
        permissions: FV_ROUTE_PERMISSIONS,
    },
});

function FeatureVideosLayout() {
    return <Outlet />;
}
